import React from "react";

function InterviewImpression({ ratingCategories, currentRatingCategory }) {
  return (
    <div className="row">
      <div
        className="col-sm-2"
        style={{ fontWeight: "bold", fontSize: "1rem" }}
      >
        Overall Impression
      </div>
      {ratingCategories.map((category, index) => (
        <div key={index} className="col-md-2">
          <div
            style={{
              fontSize: "1rem",
              fontWeight: 600,
              color:
                currentRatingCategory &&
                currentRatingCategory.label === category.label
                  ? "#E09552"
                  : "inherit",
              transition: "color 0.3s ease",
            }}
          >
            {category.label}
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color:
                currentRatingCategory &&
                currentRatingCategory.label === category.label
                  ? "#E09552"
                  : "#6c757d",
              transition: "color 0.3s ease",
            }}
          >
            {category.range[0]}-{category.range[1]} points
          </div>
        </div>
      ))}
    </div>
  );
}

export default InterviewImpression;
